import factory from './icon';
import Svg24x24 from './Glyphs/Bag_24x24.svg';
import SvgFull24x24 from './Glyphs/BagFull_24x24.svg';

export const Cart24x24 = factory(Svg24x24, 24, 24);
export const CartFull24x24 = factory(SvgFull24x24, 24, 24);
